
import { api } from './base';

export type BannerSeverity = 'error' | 'warning' | 'success' | 'info';
export type BannerAudience = 'all' | 'staff' | 'requesters';
export type BannerStatus = 'active' | 'scheduled' | 'finished' | 'archived';

export interface Banner {
  id: string;
  text: string;
  severity: BannerSeverity;
  linkUrl: string | null;
  linkLabel: string | null;
  dismissible: boolean;
  massIncidentId: string | null;
  updatedAt: string;
}

export interface AdminBanner extends Banner {
  audience: BannerAudience;
  roleKeys: string[];
  clientIds: string[];
  isPublic: boolean;
  startsAt: string | null;
  endsAt: string | null;
  createdBy: string | null;
  createdAt: string;
  status: BannerStatus;
}

export interface BannerInput {
  text: string;
  severity: BannerSeverity;
  linkUrl?: string | null;
  linkLabel?: string | null;
  audience: BannerAudience;
  roleKeys: string[];
  clientIds: string[];
  isPublic: boolean;
  dismissible: boolean;
  startsAt: string | null;
  endsAt: string | null;
  massIncidentId?: string | null;
}

export const bannersApi = {
  mine: () => api.get<Banner[]>('/api/v1/banners', undefined, { toast: false }),
  public: () => api.get<Banner[]>('/api/v1/banners/public', undefined, { toast: false }),

  adminList: () => api.get<AdminBanner[]>('/api/v1/admin/banners'),
  create: (dto: BannerInput) =>
    api.post<AdminBanner>('/api/v1/admin/banners', dto, { toast: { success: 'Баннер повешен' } }),
  update: (id: string, dto: BannerInput) =>
    api.patch<AdminBanner>(`/api/v1/admin/banners/${id}`, dto, {
      toast: { success: 'Баннер обновлён' },
    }),
  archive: (id: string) =>
    api.delete<void>(`/api/v1/admin/banners/${id}`, { toast: { success: 'Баннер снят' } }),
};
